import { MapItemWithCoodId } from "@/types/search";
import React from "react";
import { GenericProjectsList } from "./generic-projects-list";

interface MatchingProjectsListProps {
	projectData: MapItemWithCoodId[];
	locationName: string | null;
	columnsCount: number;
	locationPropertyCount?: number;
}

export const MatchingProjectsList = React.memo(function MatchingProjectsList({
	projectData,
	locationName,
	columnsCount,
	locationPropertyCount,
}: MatchingProjectsListProps) {
	const headerContent = React.useCallback(
		({ count }: { count: number }) => {
			// When locationName exists, use the count for that specific location
			// Otherwise use the total count
			const displayCount = locationName ? (locationPropertyCount ?? 0) : count;

			// Only show header if there are properties AND a location name (project mode)
			if (displayCount > 0 && locationName) {
				const propertyText = displayCount === 1 ? "property" : "properties";
				return {
					text: `${displayCount} ${propertyText} in ${locationName}`,
					icon: (
						<svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
						</svg>
					),
				};
			}
			return null;
		},
		[locationName, locationPropertyCount],
	);

	return <GenericProjectsList projectData={projectData} columnsCount={columnsCount} headerContent={headerContent} />;
});
